import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHerokuComponent } from './simple-icons-heroku.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHerokuComponent ],
    exports:      [ SimpleIconsHerokuComponent ],
    bootstrap:    []
})
export class SimpleIconsHerokuModule {}
